import ListCreditScoreByIndustryBox from './ListCreditScoreByIndustryBox'

export default ListCreditScoreByIndustryBox
